import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { Space } from 'antd';
import CheckContainer from 'components/CheckContainer';

export interface CurrencyCheckboxProps {
  currencies: General.Currency[];
  value: General.Currency;
  onChange: (value: General.Currency) => void;
}

const CurrencyCheckbox = (props: CurrencyCheckboxProps) => {
  const { value: currency, currencies, onChange } = props;
  const { t } = useTranslate();
  const { airwallexEnable } = useOrgConfigStateValue();

  const renderCurrencyList = useMemo(() => {
    return currencies.map((value) => {
      const tv = t(`currency.${value}` as string);
      return (
        <CheckContainer
          key={value}
          style={{ borderRadius: 4 }}
          checked={currency === value}
          onChange={(checked) => {
            if (checked) {
              onChange(value);
            }
          }}
        >
          <Space>
            <span>{tv}</span>
            {tv !== value && <span>({value})</span>}
          </Space>
        </CheckContainer>
      );
    });
  }, [t, currencies, currency, onChange]);

  return airwallexEnable ? (
    <div>
      <h4>{t('managementCenter.sellerPlan.subscriptionTab.section.currency')}</h4>
      <div className="flex flex-wrap gap-3">{renderCurrencyList}</div>
    </div>
  ) : null;
};

export default CurrencyCheckbox;
